import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { money } from "@/lib/format";

/** Seller's Advantage: 4.75% total commission vs a traditional 6%. */
export const SellerSavings = () => {
  const [price, setPrice] = useState(450000);
  const six = price * 0.06;
  const ours = price * 0.0475;
  return (
    <div className="grid gap-8 rounded-md bg-ink p-7 text-white sm:p-10 lg:grid-cols-[1.2fr_1fr]" data-testid="seller-savings">
      <div>
        <p className="eyebrow !text-brass">Savings calculator</p>
        <p className="mt-3 font-display text-3xl sm:text-4xl">What would 4.75% save you?</p>
        <div className="mt-8 flex items-baseline justify-between">
          <span className="text-[14px] text-white/70">Expected sale price</span>
          <span className="text-2xl font-medium" data-testid="seller-savings-price">{money(price)}</span>
        </div>
        <Slider value={[price]} min={150000} max={1500000} step={5000} onValueChange={([v]) => setPrice(v)}
          className="mt-4 [&_[role=slider]]:border-brass [&_[role=slider]]:bg-white [&>span:first-child]:bg-white/20 [&>span:first-child>span]:bg-brass" data-testid="seller-savings-slider" />
        <div className="mt-8 grid grid-cols-2 gap-4 text-[14px]">
          <div className="rounded-md border border-white/15 p-4"><p className="text-white/60">Traditional 6%</p><p className="mt-1 text-xl">{money(six)}</p></div>
          <div className="rounded-md border border-brass/60 p-4"><p className="text-white/60">Seller's Advantage 4.75%</p><p className="mt-1 text-xl">{money(ours)}</p></div>
        </div>
      </div>
      <div className="flex flex-col justify-center rounded-md bg-white/5 p-6 text-center">
        <p className="text-[13px] uppercase tracking-[0.18em] text-white/60">You keep</p>
        <p className="mt-2 font-display text-6xl text-brass" data-testid="seller-savings-result">{money(six - ours)}</p>
        <p className="mt-3 text-[14px] text-white/70">more at closing on a {money(price)} sale.</p>
      </div>
    </div>
  );
};
